"use client";

import * as React from "react";
import Image from "next/image";

import { cn } from "@/lib/utils";
import { TermsDialogLink, PrivacyDialogLink } from "@/components/legal-dialog";
import { UserRegisterForm } from "./user-register-form";

export function UserSignUpFormWrapper({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className="lg:p-8">
      <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
        <div className="flex flex-col justify-center space-y-2 text-center">
          <div className="flex justify-center">
            <Image
              src="/SnapNrack - All Blue - no tag.png"
              width={140}
              height={30}
              alt="SnapNrack"
              className="dark:hidden"
            />
            <Image
              src="/SnapNrack - White - no tag.png"
              width={140}
              height={30}
              alt="SnapNrack"
              className="hidden dark:block"
            />
          </div>
          <p className="text-sm text-muted-foreground">
            Please register below to create your account
          </p>
        </div>

        <div className={cn("grid gap-6", className)} {...props}>
          <UserRegisterForm />
        </div>

        <p className="px-8 text-center text-sm text-muted-foreground">
          By clicking continue, you agree to our{" "}
          <TermsDialogLink className="underline underline-offset-4 hover:text-primary" />{" "}
          and{" "}
          <PrivacyDialogLink className="underline underline-offset-4 hover:text-primary" />
          .
        </p>
      </div>
    </div>
  );
}

